export default {
  siteName: '51吃瓜官网',
  siteTagline: '全网最新吃瓜入口',
  nav: {
    home: '首页',
    celebrityGossip: '明星八卦',
    exclusiveScoop: '独家爆料',
    varietyHot: '综艺热点',
    filmTvNews: '影视资讯',
    influencerNews: '网红动态',
    about: '关于我们',
  },
  footer: {
    aboutTitle: '关于51吃瓜官网',
    aboutDesc: '51吃瓜官网是全网最新吃瓜入口，提供独家爆料与今日最热八卦实时追踪。每日更新海量娱乐八卦资讯，全部免费在线浏览。',
    quickLinks: '快速链接',
    categories: '内容分类',
    contactTitle: '联系我们',
    contactEmail: 'hello@yjpslu.cn',
    contactWechat: '微信：51chigua_official',
    copyright: '© 2026 51吃瓜官网 版权所有',
    icp: '沪ICP备2024XXXXXX号',
  },
  readMore: '阅读全文',
  viewAll: '查看全部',
  hot: '热门',
  exclusive: '独家',
  views: '阅读',
  publishedOn: '发布于',
  backToHome: '返回首页',
  search: '搜索八卦...',
  loading: '加载中...',
  noMore: '没有更多了',
  shareTitle: '分享到',
  relatedArticles: '相关推荐',
  breadcrumbHome: '首页',
  articlesCount: '篇文章',
  noArticles: '暂无文章',
  tags: '标签',
  prevArticle: '上一篇',
  nextArticle: '下一篇',
  articlesInCategory: '篇',
  exploreChannels: '探索频道',
  channelSwitch: '切换频道',
  hotTags: '热门标签',
}